import React from 'react';
import compose from 'recompose/compose';
import MuiGridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import IconButton from '@material-ui/core/IconButton';
import ContentShow from '@material-ui/icons/Edit';

import { Link } from 'react-router-dom';
import { linkToRecord } from 'ra-core';

const styles = {
  root: {
    // margin: '-2px',
  },
  gridList: {
    // width: '100%',
    // margin: 0,
  },
  tile: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  coverImg: {
    width: 'auto',
    maxWidth: '90%',
    height: 'auto',
    maxHeight: '100%',
    position: 'initial',
    left: 'initial',
    transform: 'initial',
  },
  imgFullHeight: {
    height: 'auto',
    maxHeight: '100%',
  },
  tileBar: {
    background: 'rgba(0,0,0,0.4)',
  },
  title: {
    color: '#fff',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  price: {
    display: 'inline',
    fontSize: '1em',
  },
  link: {
    color: '#fff',
  },
};

const getColsForWidth = width => {
  if (width === 'xs') return 2;
  if (width === 'sm') return 3;
  if (width === 'md') return 4;
  if (width === 'lg') return 5;
  return 6;
};

const GridList = ({ classes, ids, data, basePath, width }) => (
  <div className={classes.root}>
    <MuiGridList cellHeight={180} cols={getColsForWidth(width)} className={classes.gridList}>
      {ids.map(id => (
        <GridListTile
          key={id}
          classes={{
            tile: classes.tile,
            imgFullWidth: classes.coverImg,
            imgFullHeight: classes.coverImg,
          }}
        >
          <img src={data[id].logo_url} alt="" />
          <GridListTileBar
            className={classes.tileBar}
            title={
              <Link to={linkToRecord(basePath, data[id].id)} className={classes.title}>
                {data[id].name}
              </Link>
            }
            actionIcon={
              <IconButton to={linkToRecord(basePath, data[id].id)} className={classes.link} component={Link}>
                <ContentShow />
              </IconButton>
            }
          />
        </GridListTile>
      ))}
    </MuiGridList>
  </div>
);

const enhance = compose(
  withWidth(),
  withStyles(styles),
);

export default enhance(GridList);



// WEBPACK FOOTER //
// ./src/containers/CarBrand/GridList.js